/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const AppType = core.serialization.enum_([
    "PORTAL",
    "PROJECTS",
    "MAPPING",
    "WORKBOOKS",
    "CUSTOM",
]);
